import {
  deleteDoc,
  doc,
  FirestoreError,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { firestore } from "..";
import UserDataStore from "../../../store/UserDataStore";
import { CollectionName } from "../types/collections.types";
import { Incident } from "../types/incident.types";
import { createCollection, subscribeCollection } from "./collectionService";

const incidentCollection = createCollection<Incident>(CollectionName.INCIDENTS);

export const subscribeIncidents = (
  onNewSnapshot: (incidents: Incident[]) => void,
  onError: (err: FirestoreError) => void
) => {
  const user = UserDataStore.currentUser;
  if (!user?.userId) return;
  const incidentQuery = query(
    incidentCollection,
    where("userId", "==", user?.userId),
    orderBy("created", "desc")
  );
  return subscribeCollection<Incident>(incidentQuery, onNewSnapshot, onError);
};

export const deleteIncident = async (incidentId: string) => {
  const incidentRef = doc(firestore, CollectionName.INCIDENTS, incidentId);
  return await deleteDoc(incidentRef);
};

export default incidentCollection;
